// import Vue from 'vue'
// import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        redirect: {
            name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () =>
            import ('@/components/information/broadcast.vue'),
    },
    {
        path: '/financing',
        name: 'financing',
        component: () =>
            import ('@/components/information/financing.vue'),
    },
    {
        path: '/drygoods',
        name: 'drygoods',
        component: () =>
            import ('@/components/information/drygoods.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/components/information/project.vue'),
    },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ('@/components/research/report.vue'),
    },
    {
        path: '/list',
        name: 'list',
        component: () =>
            import ('@/components/research/list.vue'),
    },
    {
        path: '/Deconomy',
        name: 'Deconomy',
        component: () =>
            import ('@/components/data/Deconomy.vue'),
    },
    {
        path: '/horse',
        name: 'horse',
        component: () =>
            import ('@/components/data/horse.vue'),
    },
    {
        path: '/Idigitization',
        name: 'Idigitization',
        component: () =>
            import ('@/components/data/Idigitization.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () =>
            import ('@/components/complaints/complainList.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router